import type { ModuleConfiguration } from '@interhyp/platform-module';

import type { ContainerRegistry } from '../types/ContainerRegistry.js';
import type { ModuleName } from '../types/ModuleName.js';

declare const __webpack_init_sharing__: (scope: string) => Promise<void>;
declare const __webpack_share_scopes__: {
  default: Record<string, unknown>;
};

export const getModuleImport = async ({ scope, specifier }: ModuleName) => {
  await __webpack_init_sharing__('default');

  const container = (window as unknown as ContainerRegistry<ModuleConfiguration>)[scope];

  if (!container) {
    throw new Error(`Container "${scope}" not present (specifier: ${specifier})`);
  }

  try {
    await container.init(__webpack_share_scopes__.default);
  } catch {
    // Already initialized. Ignore
  }

  const factory = await container.get(specifier);
  const module = await factory();
  return module.default;
};
